import { render, staticRenderFns } from "./MyOrderStatusIndex.vue?vue&type=template&id=ae9805c6&"
import script from "./MyOrderStatusIndex.vue?vue&type=script&lang=js&"
export * from "./MyOrderStatusIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports